import React from 'react'

const Pytm5 = () => {
    return (
        <div className='container'>
        <h1>Maximum sum such that no two elements are adjacent</h1>
        <p>Given an array of positive numbers, find the maximum sum of a subsequence with the constraint that no 2 numbers in the sequence should be adjacent in the array. So 3 2 7 10 should return 13 (sum of 3 and 10) or 3 2 5 10 7 should return 15 (sum of 3, 5 and 7).Answer the question in most efficient way.</p>
        <p><strong>Examples : </strong></p>
        <pre classNamw='containers'>{`Input : arr[] = {5, 5, 10, 100, 10, 5}
Output : 110

Input : arr[] = {1, 2, 3}
Output : 4

Input : arr[] = {1, 20, 3}
Output : 20`}</pre>
<p><strong>Algorithm:</strong>&nbsp;<br/>
Loop for all elements in arr[] and maintain two sums incl and excl where incl = Max sum including the previous element and excl = Max sum excluding the previous element.<br/>
Max sum excluding the current element will be max(incl, excl) and max sum including the current element will be excl + current element (Note that only excl is considered because elements cannot be adjacent).<br/>
At the end of the loop return max of incl and excl.</p>
<p><strong>Example:</strong>&nbsp;&nbsp;</p>
<pre>{`  arr[] = {5,  5, 10, 40, 50, 35}

  incl = 5 
  excl = 0

  For i = 1 (current element is 5)
  incl =  (excl + arr[i])  = 5
  excl =  max(5, 0) = 5

  For i = 2 (current element is 10)
  incl =  (excl + arr[i]) = 15
  excl =  max(5, 5) = 5

  For i = 3 (current element is 40)
  incl = (excl + arr[i]) = 45
  excl = max(5, 15) = 15

  For i = 4 (current element is 50)
  incl = (excl + arr[i]) = 65
  excl =  max(45, 15) = 45

  For i = 5 (current element is 35)
  incl =  (excl + arr[i]) = 80
  excl =  max(65, 45) = 65

And 35 is the last element. So, answer is max(incl, excl) =  80`}</pre>

        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">//c++ program for the above approach</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1">&nbsp;</div>
    <div class="line number7 index6 alt2"><code
            class="comments">/*Function to return max sum such that no two elements</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">are adjacent */</code></div>
    <div class="line number9 index8 alt2"><code class="color1 bold">int</code> <code
            class="plain">FindMaxSum(vector&lt;</code><code class="color1 bold">int</code><code
            class="plain">&gt; arr, </code><code class="color1 bold">int</code> <code class="plain">n)</code></div>
    <div class="line number10 index9 alt1"><code class="plain">&#123;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">incl = arr[0];</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">excl = 0;</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">excl_new;</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i;</code></div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i = 1; i &lt; n; i++)</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max excluding i */</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl_new = (incl &gt; excl) ? incl : excl;</code></div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max including i */</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">incl = excl + arr[i];</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl = excl_new;</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* return max of incl and excl */</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">((incl &gt; excl) ? incl : excl);</code></div>
    <div class="line number28 index27 alt1"><code class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2">&nbsp;</div>
    <div class="line number30 index29 alt1"><code class="comments">// Driver program to test above functions</code>
    </div>
    <div class="line number31 index30 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number32 index31 alt1"><code class="plain">&#123;</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">vector&lt;</code><code class="color1 bold">int</code><code
            class="plain">&gt; arr = &#123;5, 5, 10, 100, 10, 5&#125;;</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout&lt;&lt;FindMaxSum(arr, arr.size());</code></div>
    <div class="line number35 index34 alt2"><code class="plain">&#125;</code></div>
</div>
</div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="keyword">class</code> <code class="plain">MaximumSum</code></div>
    <div class="line number2 index1 alt1"><code class="plain">&#123;</code></div>
    <div class="line number3 index2 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/*Function to return max sum such that no two elements</code></div>
    <div class="line number4 index3 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">are adjacent */</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">FindMaxSum(</code><code class="keyword">int</code> <code
            class="plain">arr[], </code><code class="keyword">int</code> <code class="plain">n)</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">incl = arr[</code><code class="value">0</code><code
            class="plain">];</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">excl = </code><code class="value">0</code><code
            class="plain">;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">excl_new;</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">i;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(i = </code><code class="value">1</code><code
            class="plain">; i &lt; n; i++)</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max excluding i */</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl_new = (incl &gt; excl) ? incl : excl;</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max including i */</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">incl = excl + arr[i];</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl = excl_new;</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* return max of incl and excl */</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">((incl &gt; excl) ? incl : excl);</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Driver program to test above functions</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">MaximumSum sum = </code><code class="keyword">new</code> <code
            class="plain">MaximumSum();</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr[] = </code><code class="keyword">new</code> <code
            class="keyword">int</code><code class="plain">[]&#123;</code><code class="value">5</code><code
            class="plain">, </code><code class="value">5</code><code class="plain">, </code><code
            class="value">10</code><code class="plain">, </code><code class="value">100</code><code
            class="plain">, </code><code class="value">10</code><code class="plain">, </code><code
            class="value">5</code><code class="plain">&#125;;</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(sum.FindMaxSum(arr, arr.length));</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code
            class="comments">// This code has been contributed by Mayank Jaiswal</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Function to return max sum such that</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># no two elements are adjacent</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">def</code> <code class="plain">find_max_sum(arr):</code>
    </div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">incl </code><code class="keyword">=</code> <code class="value">0</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl </code><code class="keyword">=</code> <code class="value">0</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="plain">arr:</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Current max excluding i (No ternary in</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Python)</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_excl </code><code class="keyword">=</code> <code class="plain">excl </code><code
            class="keyword">if</code> <code class="plain">excl&gt;incl </code><code class="keyword">else</code> <code
            class="plain">incl</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Current max including i</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">incl </code><code class="keyword">=</code> <code class="plain">excl </code><code
            class="keyword">+</code> <code class="plain">i</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl </code><code class="keyword">=</code> <code class="plain">new_excl</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># return max of incl and excl</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">(excl </code><code class="keyword">if</code> <code
            class="plain">excl&gt;incl </code><code class="keyword">else</code> <code class="plain">incl)</code></div>
    <div class="line number19 index18 alt2">&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="comments"># Driver program to test above function</code></div>
    <div class="line number21 index20 alt2"><code class="plain">arr </code><code class="keyword">=</code> <code
            class="plain">[</code><code class="value">5</code><code class="plain">, </code><code
            class="value">5</code><code class="plain">, </code><code class="value">10</code><code
            class="plain">, </code><code class="value">100</code><code class="plain">, </code><code
            class="value">10</code><code class="plain">, </code><code class="value">5</code><code class="plain">]</code>
    </div>
    <div class="line number22 index21 alt1"><code class="functions">print</code> <code
            class="plain">find_max_sum(arr)</code></div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code class="comments"># This code is contributed by Kalai Selvan</code>
    </div>
</div>
 </div>
  <div id="tab-content-4" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="preprocessor">#include&lt;stdio.h&gt;</code></div>
    <div class="line number2 index1 alt1">&nbsp;</div>
    <div class="line number3 index2 alt2"><code
            class="comments">/*Function to return max sum such that no two elements</code></div>
    <div class="line number4 index3 alt1"><code class="comments">are adjacent */</code></div>
    <div class="line number5 index4 alt2"><code class="color1 bold">int</code> <code
            class="plain">FindMaxSum(</code><code class="color1 bold">int</code> <code class="plain">arr[], </code><code
            class="color1 bold">int</code> <code class="plain">n)</code></div>
    <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="color1 bold">int</code> <code class="plain">incl = arr[0];</code>
    </div>
    <div class="line number8 index7 alt1"><code class="color1 bold">int</code> <code class="plain">excl = 0;</code>
    </div>
    <div class="line number9 index8 alt2"><code class="color1 bold">int</code> <code class="plain">excl_new;</code>
    </div>
    <div class="line number10 index9 alt1"><code class="color1 bold">int</code> <code class="plain">i;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="keyword bold">for</code> <code
            class="plain">(i = 1; i &lt; n; i++)</code></div>
    <div class="line number13 index12 alt2"><code class="plain">&#123;</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max excluding i */</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl_new = (incl &gt; excl)? incl: excl;</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* current max including i */</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">incl = excl + arr[i];</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">excl = excl_new;</code></div>
    <div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code class="comments">/* return max of incl and excl */</code></div>
    <div class="line number23 index22 alt2"><code class="keyword bold">return</code> <code
            class="plain">((incl &gt; excl)? incl : excl);</code></div>
    <div class="line number24 index23 alt1"><code class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="comments">/* Driver program to test above function */</code>
    </div>
    <div class="line number27 index26 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number28 index27 alt1"><code class="plain">&#123;</code></div>
    <div class="line number29 index28 alt2"><code class="color1 bold">int</code> <code
            class="plain">arr[] = &#123;5, 5, 10, 100, 10, 5&#125;;</code></div>
    <div class="line number30 index29 alt1"><code class="color1 bold">int</code> <code class="plain">n = </code><code
            class="keyword bold">sizeof</code><code class="plain">(arr) / </code><code
            class="keyword bold">sizeof</code><code class="plain">(arr[0]);</code></div>
    <div class="line number31 index30 alt2"><code class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"%d n"</code><code class="plain">, FindMaxSum(arr, n));</code></div>
    <div class="line number32 index31 alt1"><code class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
</div>
 </div>
 </div>
</div>
<br /> <br /> <br /> <br />
</div>
    )
}

export default Pytm5
